<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
    <div>
      <vx-card ref="filterCard" :title="$t('general.filters')" class="user-list-filters mb-8" collapse-action>
        <div class="mb-5 vx-row">
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.contractNo") }}</label>
            <vs-input type="text" v-model="form.contractNo" class="w-full" v-on:keyup.enter="onEnter()"/>
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.contractName") }}</label>
            <vs-input type="text" v-model="form.contractName" class="w-full" v-on:keyup.enter="onEnter()"/>
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.educationStatus") }}</label>
            <v-select v-model="form.educationStatus" :clearable="true" :options="educationStatusesOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.year") }}</label>
            <v-select v-model="form.year" :clearable="true" :options="yearsOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.project") }}</label>
            <v-select v-model="form.project" :clearable="true" :options="projectOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{$t('sections.accounting.dataForm.faculty')}}/{{$t('sections.accounting.dataForm.curriculum')}}</label>
            <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" name="curriculum" :reduce="res => res.value" disalbed />
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.loan.loanType") }}</label>
            <v-select v-model="form.loanType" :clearable="true" :options="loanTypesOptions" name="loanType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-full lg:w-1/4 md:w-1/3 ">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.agingNumber") }}</label>
            <v-select v-model="form.hierarchy" :clearable="true" :options="hierarchysOptions" name="loanType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>
        <div class="flex">
          <div class="flex flex-1 px-2">
            <vs-button class="ml-auto mx-1" @click="search()">{{ $t("general.search") }}</vs-button>
            <vs-button type="border" class="mx-1" color="warning" @click="reset()">{{ $t("general.reset") }}</vs-button>
          </div>
        </div>
      </vx-card>
      <div class="vx-row mb-base mb-5" v-if="contractsTrackDownDebtByFilters.length">
        <div class="vx-col w-full sm:w-1/2">
          <vx-card>
            <div class="vx-row">
              <div class="vx-col w-full vx-coll-fixed-height">
                <div class="flex pb-5">
                  <div class="flex-1">
                    {{ $t("sections.accounting.dataForm.itemCounts", { max: contractsTrackDownDebtByFilters.length }) }}
                  </div>
                </div>
                <vs-table :data="contractsTrackDownDebtByFilters" >
                  <template slot="thead">
                    <vs-th sort-key="loanType">{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
                    <vs-th sort-key="loanType">{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
                    <vs-th sort-key="loanType">{{ $t("sections.accounting.dataForm.agingNumber") }}</vs-th>
                    <vs-th sort-key="loanType"></vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :data="res" :key="indextr" v-for="(res, indextr) in data">
                      <vs-td :data="res.contractNo">
                        <a @click="viewTransaction(res.id)" class="cursor-pointer">{{ res.contractNo }} </a><b><u>{{ res.contractSeq }}</u></b>
                      </vs-td>
                      <vs-td :data="res.contractName">
                        {{ res.contractName }}
                      </vs-td>
                      <vs-td :data="res.agingNumber">
                        {{ res.agingNumber + " วัน"}}
                      </vs-td>
                      <vs-td :data="res.contractName">
                        <div class="vx-col w-full">
                          <vs-button class="ml-auto" size="small" @click="view(res.id)">{{ "เรียกดู" }}</vs-button>
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-1/2">
          <contract-header-detail  v-bind:manage="false"></contract-header-detail>
        </div>
      </div>
    </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex'
import ContractHeaderDetail from "../Transaction/Manage/ContractHeaderDetail";
import vSelect from 'vue-select'
import { round } from '@/utils'
const {mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
const {mapActions: mapMasterActions, mapState: mapMasterState } = createNamespacedHelpers('Master')

export default {
  components: {
    ContractHeaderDetail,
    vSelect
  },
  data () {
    return {
      form:{
        year: "",
        educationStatus: "",
        project: "",
        loanType: "",
        curriculum: "",
        contractNo: "",
        contractName: "",
        hierarchy: 0,
        // agingNumber: 121,
      },
      user: "",
      selected: [],
      loading: false
    }
  },
  async created () {
    const vm = this
    if(vm.$route.params.contractNo){
      await vm.initData({
        contractNo: vm.$route.params.contractNo
      });
    }else{
      await vm.initData();
    }

  },
  computed: {
    ...mapAccountingState([ 'status', 'contractsTrackDownDebtByFilters', 'contract']),
    ...mapMasterState(["curriculums", "transactionFilters"]),
    ...mapGetters({
      yearsOptions: "Master/yearsOptions",
      educationStatusesOptions: "Master/educationStatusesOptions",
      projectOptions: "Master/projectOptions",
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      loanTypesOptions: "Master/loanTypesOptions",
      hierarchysOptions: "Master/hierarchysOptions",
    }),
    contractAmount() {
      return this.contractsTrackDownDebtByFilters.reduce((sum, res) => { return sum + round(res.contractAmount, 2) }, 0)
    },
    loanAmount() {
      return this.contractsTrackDownDebtByFilters.reduce((sum, res) => { return sum + round(res.loanAmount, 2) }, 0)
    },
    principleRemain() {
      return this.contractsTrackDownDebtByFilters.reduce((sum, res) => { return sum + round(res.principleRemain, 2) }, 0)
    },
    accruedFeeRemain() {
      return this.contractsTrackDownDebtByFilters.reduce((sum, res) => { return sum + round(res.accruedFeeRemain, 2) }, 0)
    },
    accruedPenaltyRemain() {
      return this.contractsTrackDownDebtByFilters.reduce((sum, res) => { return sum + round(res.accruedPenaltyRemain, 2) }, 0)
    },
    accruedInterestRemain() {
      return this.contractsTrackDownDebtByFilters.reduce((sum, res) => { return sum + round(res.accruedInterestRemain, 2) }, 0)
    },
  },
  methods: {
    ...mapAccountingActions(['getContractsTrackDownDebtByFilters', 'getContract', 'clearContract']),
    ...mapMasterActions(['getProjects', 'getCurriculums', 'setTransactionFilters']),
    async viewTransaction (id) {
      await this.$router.push({name: 'accounting-contract-detail', params: { id: id }});
    },
    async onEnter(){
      await this.search()
    },
    async search (){
      const vm = this
      if(!vm.loading){vm.$vs.loading()}
      vm.loading = false
      const { setTransactionFilters, getContractsTrackDownDebtByFilters } = vm
      await setTransactionFilters({
        year: vm.form.year,
        educationStatus: vm.form.educationStatus,
        project: vm.form.project,
        loanType: vm.form.loanType,
        curriculum: vm.form.curriculum,
        contractNo: vm.form.contractNo,
        contractName: vm.form.contractName,
      });

      await getContractsTrackDownDebtByFilters({
        form: {
          year: vm.form.year || 0,
          educationStatus: vm.form.educationStatus || 'Null',
          project: {id: vm.form.project || ''},
          loanType: vm.form.loanType || 'Null',
          curriculum: {id: vm.form.curriculum || ''},
          contractNo: vm.form.contractNo,
          contractName: vm.form.contractName,
          hierarchy: vm.form.hierarchy,
        }
      })
      setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
    },
    async reset(){
      this.form = {
        year: "",
        educationStatus: "",
        project: "",
        loanType: "",
        curriculum: "",
        contractNo: "",
        contractName: "",
        hierarchy: 0,
        // agingNumber: 121,
      }
      await this.search ()
    },
    async initData(args){
      const vm = this
      const { clearContract } = vm
      await clearContract();
      if(args){
        vm.form = {
          year: "",
          educationStatus: "",
          project: "",
          loanType: "",
          curriculum: "",
          contractNo: args.contractNo,
          contractName: "",
          hierarchy: null,
        }
        await vm.search ()
        await vm.view(this.contractsTrackDownDebtByFilters[0].id)
      }else{
        vm.form = {
          year: vm.transactionFilters ? vm.transactionFilters.year : "",
          educationStatus: vm.transactionFilters ? vm.transactionFilters.educationStatus : "",
          project: vm.transactionFilters ? vm.transactionFilters.project : "",
          loanType: vm.transactionFilters ? vm.transactionFilters.loanType : "",
          curriculum: vm.transactionFilters ? vm.transactionFilters.curriculum : "",
          contractNo: vm.transactionFilters ? vm.transactionFilters.contractNo : "",
          contractName: vm.transactionFilters ? vm.transactionFilters.contractName : "",
          hierarchy: 0,
        }
      }
    },
    async view (id) {
      const vm = this
      const { getContract } = vm
      await getContract({form: {id: id}});
    },
    project(res){
      let project = ""
      if(res.borrower){
        project = res.borrower.project.nameTh
      }
      return project
    },
    curriculum(res){
      let curriculum = ""
      if(res.curriculum){
        curriculum = res.curriculum.faculty.nameTh+'/'+res.curriculum.nameTh
      }
      return curriculum
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
}
</script>


<style scoped>
  .vx-coll-fixed-height{
    display:block;
    width:100%;
    height:500px;
    overflow: auto;
  }
</style>
